import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { useLocation, useNavigate } from "react-router";
import { alertActions } from "../../_actions/alert.actions";
import { Link } from "react-router-dom";
import { Loading } from "@pages/Other/Loading";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { courseService, countryService, cityService } from "../../_services";
import "./signUpPage.scss";
import {
  validateFirstName,
  validateLastName,
  validatePhoneNumber,
  emailVaildation,
  street_vaildation,
  userNa,
  pwd,
  validateUnitNumber,
  validatePinCode,
  validateCountryName,
  validateProvinceName,
  validateCityName,
} from "../../_helpers/utilities";
import SignupOverlay from "./SignupOverlay";
import useAnalyticsEventTracker from "@pages/Other/useAnalyticsEventTracker";
import ImageSlider from "./ImageSlider";
import { Lock, Phone, User, Mail, MapPin, Sun, Moon, Eye, EyeOff } from "lucide-react";

const TOTAL_SLIDES = 1;

function SignupPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [city, setCities] = useState([]);

  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    localStorage.setItem("theme", newMode ? "dark" : "light");
  };

  const themeClass = darkMode ? "dark" : "light";
  const bgClass = darkMode ? "bg-slate-950 text-white" : "bg-gradient-to-br from-indigo-50 via-slate-100 to-blue-50 text-slate-900";
  const cardClass = darkMode 
    ? "bg-slate-900/80 border-slate-800 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.7)]" 
    : "bg-white/95 border-slate-200/80 shadow-[0_25px_60px_-15px_rgba(15,23,42,0.1)]";
  const formSectionClass = darkMode ? "bg-slate-900/40" : "bg-slate-50/50";
  const titleClass = darkMode ? "text-white" : "text-slate-900";
  const textMutedClass = darkMode ? "text-slate-400" : "text-slate-500";
  const borderClass = darkMode ? "border-slate-800" : "border-slate-200";
  const inputClass = darkMode
    ? "w-full !pl-12 !pr-4 !py-3.5 !bg-slate-950/50 hover:!bg-slate-950/80 focus:!bg-slate-950 !border !border-slate-800 focus:!border-blue-500 focus:!ring-2 focus:!ring-blue-500/20 !text-white placeholder-slate-600 !rounded-2xl transition-all duration-300 text-sm outline-none shadow-[inset_0_2px_4px_rgba(0,0,0,0.6)]"
    : "w-full !pl-12 !pr-4 !py-3.5 !bg-slate-100/50 hover:!bg-slate-100/85 focus:!bg-white !border !border-slate-200 focus:!border-blue-500 focus:!ring-2 focus:!ring-blue-500/20 !text-slate-900 placeholder-slate-400 !rounded-2xl transition-all duration-300 text-sm outline-none shadow-[inset_0_1px_3px_rgba(0,0,0,0.06)]";
  const inputSelectClass = darkMode
    ? "w-full !pl-12 !pr-8 !py-3.5 !bg-slate-950/50 hover:!bg-slate-950/80 focus:!bg-slate-950 !border !border-slate-800 focus:!border-blue-500 focus:!ring-2 focus:!ring-blue-500/20 !text-white placeholder-slate-600 !rounded-2xl transition-all duration-300 text-sm outline-none shadow-[inset_0_2px_4px_rgba(0,0,0,0.6)] appearance-none cursor-pointer"
    : "w-full !pl-12 !pr-8 !py-3.5 !bg-slate-100/50 hover:!bg-slate-100/85 focus:!bg-white !border !border-slate-200 focus:!border-blue-500 focus:!ring-2 focus:!ring-blue-500/20 !text-slate-900 placeholder-slate-400 !rounded-2xl transition-all duration-300 text-sm outline-none shadow-[inset_0_1px_3px_rgba(0,0,0,0.06)] appearance-none cursor-pointer";
  const inputPasswordClass = darkMode
    ? "w-full !pl-12 !pr-16 !py-3.5 !bg-slate-950/50 hover:!bg-slate-950/80 focus:!bg-slate-950 !border !border-slate-800 focus:!border-blue-500 focus:!ring-2 focus:!ring-blue-500/20 !text-white placeholder-slate-600 !rounded-2xl transition-all duration-300 text-sm outline-none shadow-[inset_0_2px_4px_rgba(0,0,0,0.6)]"
    : "w-full !pl-12 !pr-16 !py-3.5 !bg-slate-100/50 hover:!bg-slate-100/85 focus:!bg-white !border !border-slate-200 focus:!border-blue-500 focus:!ring-2 focus:!ring-blue-500/20 !text-slate-900 placeholder-slate-400 !rounded-2xl transition-all duration-300 text-sm outline-none shadow-[inset_0_1px_3px_rgba(0,0,0,0.06)]";
  const iconClass = darkMode ? "text-slate-500 group-focus-within:text-blue-500" : "text-slate-400 group-focus-within:text-blue-500";
  const tabsBgClass = darkMode ? "bg-slate-950/80 border-slate-800" : "bg-slate-100 border-slate-200";
  const dropdownArrowClass = darkMode ? "text-slate-400" : "text-slate-500";

  const location = useLocation();
  const { state } = location;
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState(0);
  const [error, setError] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [verificationModal, setVerificationModal] = useState(false);
  const [signUpData, setSignUpData] = useState({
    role: "Student",
    firstName: "",
    lastName: "",
    email: "",
    userName: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    managePassword: false,
    manageConfirmPassword: false,
    street: "",
    unit: "",
    city: "",
    province: "",
    countryCode: "India",
    pincode: "",
  });

  const loginStatus = useSelector((state) => state.authentication.loggedIn);
  const loginStatus1 = useSelector((state) => state.authentication);
  const navigate = useNavigate();
  if (loginStatus === true) {
    navigate("/dashboard");
  }
  useEffect(() => {
    function getallcountries() {
      countryService.getCountries().then((res) => {
        const rawCountries = res?.data?.data?.map((country) => country?.name) || [];
        const uniqueCountries = [...new Set(rawCountries)];
        setCountries(uniqueCountries);
      });
    }
    getallcountries();
  }, []);


  const getstatesforcountry = () => {
    countryService.getCountries().then((res) => {
      const countryData = res?.data?.data || [];
      const selectedCountry = countryData.find(country => country.name === signUpData.countryCode);
      if (selectedCountry) {
        const rawStates = selectedCountry.states.map(state => state.name);
        const uniqueStates = [...new Set(rawStates)];
        setStates(uniqueStates);
      }
    });
  }

  const getCitiesforState = () => {
    cityService.getCities(signUpData.countryCode, signUpData.province).then((res) => {
      const rawCities = res?.data?.data || [];
      const uniqueCities = [...new Set(rawCities)];
      setCities(uniqueCities);
    }); 
  }

  useEffect(() => {
    if (signUpData.province) {
      getCitiesforState();
    } else {
      setCities([]);
    }
  }, [signUpData.province]);

  useEffect(() => {
    if (signUpData.countryCode) {
      getstatesforcountry();
    } else {
      setStates([]);
    }
  }, [signUpData.countryCode]);

  const ValidateFirstName = validateFirstName(signUpData.firstName)
    ? true
    : false;
  const ValidateLastName = validateLastName(signUpData.lastName) ? true : false;

  const ValidateEmail = emailVaildation(signUpData.email) ? true : false;

  const ValidateUserName = userNa(signUpData.userName) ? true : false;

  const ValidatePassword = pwd(signUpData.password) ? true : false;

  const ValidateConfirmPassword = pwd(signUpData.confirmPassword)
    ? true
    : false;

  const ValidatePhoneNumber = validatePhoneNumber(signUpData.phoneNumber)
    ? true
    : false;

  const ValidateCity = validateCityName(signUpData.city) ? true : false;

  const ValidateStreet = street_vaildation(signUpData.street) ? true : false;

  const ValidateUnit = validateUnitNumber(signUpData.unit) ? true : false;

  const ValidateProvince = validateProvinceName(signUpData.province)
    ? true
    : false;

  const ValidateCountryName = signUpData.countryCode === ""
    ? true
    : validateCountryName(signUpData.countryCode)
      ? true
      : false;

  const ValidatePinCode = signUpData.pincode === ""
    ? true
    : validatePinCode(signUpData.pincode)
      ? true
      : false;

  function next() {
    if (
      ValidatePhoneNumber === false ||
      ValidateUserName === false ||
      ValidateFirstName === false ||
      ValidateLastName === false ||
      ValidateEmail === false ||
      ValidatePassword === false ||
      signUpData.password !== signUpData.confirmPassword
    ) {
      setError(true);
    } else if (
      signUpData.firstName === "" ||
      signUpData.lastName === "" ||
      signUpData.email === "" ||
      signUpData.userName === "" ||
      signUpData.password === "" ||
      signUpData.confirmPassword === ""
    ) {
      setCurrent(0);
    } else {
      if (current >= TOTAL_SLIDES) return;
      else setCurrent(current + 1);
    }
  }

  // Update check for instructor role if component is mounted via teacher page banner state
  useEffect(() => {
    if (state?.comeFrom) {
      setSignUpData(prev => ({ ...prev, role: "Instructor" }));
    }
  }, [state]);

  function goBack() {
    if (current === 0) return;
    else setCurrent(current - 1);
  }
  const d = {
    firstName: signUpData.firstName,
    lastName: signUpData.lastName,
    password: signUpData.password,
    role: signUpData.role,
    phoneNumber: signUpData.phoneNumber,
    email: signUpData.email,
    userName: signUpData.userName,
    street: signUpData.street,
    unit: signUpData.unit,
    city: signUpData.city,
    province: signUpData.province,
    countryCode: signUpData.countryCode,
    pincode: signUpData.pincode,
    bio: "Default bio for ",
    profilePhoto:
      "https://images.unsplash.com/photo-1629648468144-5e9403a0916d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=763&q=80",
  };

  function handleComplete() {
    setSubmitError(true);
    if (
      signUpData.firstName === "" ||
      signUpData.email === "" ||
      ValidateEmail === false ||
      signUpData.lastName === "" ||
      signUpData.userName === "" ||
      signUpData.password === "" ||
      signUpData.phoneNumber === "" ||
      signUpData.confirmPassword === "" ||
      ValidatePinCode === false ||
      ValidateCountryName === false
    ) {
      setCurrent(1);
    } else {
      submit();
    }
  }

  const gaEventTracker = useAnalyticsEventTracker("SignUp with Teacher Banner", "Teachers", "SIGNUP_SUCCESS_TEACHER_BANNER");
  const gaEventTracker2 = useAnalyticsEventTracker("SignUp with Teacher Banner", "Teachers", "SIGNUP_FAILED_TEACHER_BANNER");

  async function submit() {
    setLoading(true);
    try {
      const res = await courseService.userSignup(d);
      setLoading(false);
      if (!res?.data?.error) {
        setVerificationModal(true);
        if (state?.comeFrom) {
          gaEventTracker();
        }
      } else {
        dispatch(
          alertActions.addAlert(
            "Error :  ",
            `${res?.data?.data?.length > 0
              ? res?.data?.data[0]?.message
              : res?.data?.message
            }`
          )
        );
        if (state?.comeFrom) {
          gaEventTracker2();
        }
      }
    } catch (error) {
      setLoading(false);
      if (state?.comeFrom) {
        gaEventTracker2();
      }
      console.log(error);
      dispatch(
        alertActions.addAlert(
          "Error :  ",
          error?.response?.data?.message || error?.message || "Registration failed. Please try again."
        )
      );
    }
  }

  const handleViewPassword = () => {
    setSignUpData({
      ...signUpData,
      managePassword: !signUpData.managePassword,
    });
  };

  const handleConfirmViewPassword = () => {
    setSignUpData({
      ...signUpData,
      manageConfirmPassword: !signUpData.manageConfirmPassword,
    });
  };

  return (
    <div className={`LoginPage min-h-screen flex items-center justify-center p-4 relative overflow-hidden select-none ${bgClass}`} style={{ fontFamily: "'Outfit', sans-serif" }}>
      {/* Floating Theme Toggle Button */}
      <button
        type="button"
        onClick={toggleDarkMode}
        className={`fixed top-6 right-6 z-50 p-3.5 rounded-full border transition-all duration-300 shadow-lg hover:scale-105 active:scale-95 ${
          darkMode
            ? "bg-slate-900 border-slate-800 text-yellow-400 hover:bg-slate-800"
            : "bg-white border-slate-200 text-slate-700 hover:bg-slate-100"
        }`}
        aria-label="Toggle Theme"
      >
        {darkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
      </button>

      {/* Loading Overlay */}
      {loading === true && (
        <div className={`absolute inset-0 flex items-center justify-center z-50 pointer-events-auto backdrop-blur-sm ${darkMode ? "bg-slate-950/70" : "bg-slate-100/70"}`}>
          <Loading />
        </div>
      )}
      
      {verificationModal && (
        <SignupOverlay
          setVerificationModal={setVerificationModal}
          verificationModal={verificationModal}
          email={signUpData.email}
        />
      )}

      {/* Main 3D Card Container */}
      <div className={`w-full max-w-5xl border rounded-[2.5rem] flex flex-col md:flex-row overflow-hidden relative z-10 ${cardClass}`}>
        
        {/* Left Side: 3D Image Slider Section */}
        <div className="w-full md:w-[45%] lg:w-[50%] min-h-[300px] md:min-h-[600px] relative overflow-hidden">
          <ImageSlider />
        </div>

        {/* Right Side: Form Section */}
        <div className={`w-full md:w-[55%] lg:w-[50%] p-8 sm:p-12 flex flex-col justify-center ${formSectionClass}`}>
          <div className="w-full max-w-md mx-auto space-y-6">
            
            {/* Step 1: User Credentials */}
            <div className={current ? "hidden" : "space-y-6"}>
              <div className="space-y-2">
                <h1 className={`text-3xl font-black tracking-tight ${titleClass}`}>
                  {t("Create Account")}
                </h1>
                <p className={`text-sm font-medium ${textMutedClass}`}>
                  Join our learning community today.
                </p>
              </div>

              {/* Role Selection Tabs */}
              <div className="space-y-2">
                <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                  {t("wannaReg")}
                </label>
                <div className={`flex p-1 rounded-2xl border shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] ${tabsBgClass}`}>
                  <button
                    type="button"
                    onClick={() => setSignUpData({ ...signUpData, role: "Student" })}
                    className={`flex-1 py-2.5 text-xs font-bold rounded-xl transition-all duration-300 ${
                      signUpData.role === "Student"
                        ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-md shadow-indigo-600/20"
                        : darkMode
                          ? "text-slate-400 hover:text-white"
                          : "text-slate-500 hover:text-slate-900"
                    }`}
                  >
                    Student
                  </button>
                  <button
                    type="button"
                    onClick={() => setSignUpData({ ...signUpData, role: "Instructor" })}
                    className={`flex-1 py-2.5 text-xs font-bold rounded-xl transition-all duration-300 ${
                      signUpData.role === "Instructor"
                        ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-md shadow-indigo-600/20"
                        : darkMode
                          ? "text-slate-400 hover:text-white"
                          : "text-slate-500 hover:text-slate-900"
                    }`}
                  >
                    Instructor
                  </button>
                </div>
              </div>

              {/* Form Fields */}
              <div className="space-y-4">
                {/* First and Last Name */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1.5">
                    <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                      {t("firstName")}
                    </label>
                    <div className="relative group">
                      <User className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${iconClass}`} />
                      <input
                        id="first_name"
                        type="text"
                        placeholder={t("firstName")}
                        value={signUpData.firstName}
                        className={inputClass}
                        onChange={({ target }) =>
                          setSignUpData({
                            ...signUpData,
                            firstName: target.value,
                          })
                        }
                      />
                    </div>
                    {error && signUpData.firstName === "" && (
                      <p className="text-red-500 text-xs font-semibold mt-1">Required</p>
                    )}
                    {error && signUpData.firstName !== "" && !ValidateFirstName && (
                      <p className="text-red-500 text-xs font-semibold mt-1">
                        First names must have a minimum of two characters.
                      </p>
                    )}
                  </div>

                  <div className="space-y-1.5">
                    <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                      {t("lastName")}
                    </label>
                    <div className="relative group">
                      <User className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${iconClass}`} />
                      <input
                        id="last_name"
                        type="text"
                        placeholder={t("lastName")}
                        value={signUpData.lastName}
                        className={inputClass}
                        onChange={({ target }) =>
                          setSignUpData({
                            ...signUpData,
                            lastName: target.value,
                          })
                        }
                      />
                    </div>
                    {error && signUpData.lastName === "" && (
                      <p className="text-red-500 text-xs font-semibold mt-1">Required</p>
                    )}
                    {error && signUpData.lastName !== "" && !ValidateLastName && (
                      <p className="text-red-500 text-xs font-semibold mt-1">
                        Last names must have a minimum of two characters.
                      </p>
                    )}
                  </div>
                </div>

                {/* Email Address */}
                <div className="space-y-1.5">
                  <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                    {t("email")}
                  </label>
                  <div className="relative group">
                    <Mail className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${iconClass}`} />
                    <input
                      id="email_ID"
                      type="text"
                      name="email"
                      placeholder={t("email")}
                      value={signUpData.email}
                      className={inputClass}
                      onChange={({ target }) =>
                        setSignUpData({ ...signUpData, email: target.value })
                      }
                    />
                  </div>
                  {error && signUpData.email === "" && (
                    <p className="text-red-500 text-xs font-semibold mt-1">Required!</p>
                  )}
                  {error && signUpData.email !== "" && !ValidateEmail && (
                    <p className="text-red-500 text-xs font-semibold mt-1">Please enter a valid email.</p>
                  )}
                </div>

                {/* Username and Phone Number */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1.5">
                    <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                      {t("username")}
                    </label>
                    <div className="relative group">
                      <User className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${iconClass}`} />
                      <input
                        id="userName"
                        type="text"
                        name="userName"
                        placeholder={t("username")}
                        value={signUpData.userName}
                        className={inputClass}
                        onChange={({ target }) =>
                          setSignUpData({ ...signUpData, userName: target.value })
                        }
                      />
                    </div>
                    {error && signUpData.userName === "" && (
                      <p className="text-red-500 text-xs font-semibold mt-1">Required!</p>
                    )}
                    {error && signUpData.userName !== "" && !ValidateUserName && (
                      <p className="text-red-500 text-xs font-semibold mt-1">
                        Must be &gt; 5 chars and no special chars.
                      </p>
                    )}
                  </div>

                  <div className="space-y-1.5">
                    <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                      {t("phoneNo")}
                    </label>
                    <div className="relative group">
                      <Phone className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${iconClass}`} />
                      <input
                        id="phoneNumber"
                        type="number"
                        pattern="[1-9]{1}[0-9]{9}"
                        name="phoneNumber"
                        maxLength={10}
                        placeholder={t("phoneNo")}
                        value={signUpData.phoneNumber}
                        className={inputClass}
                        onChange={({ target }) =>
                          setSignUpData({
                            ...signUpData,
                            phoneNumber: target.value,
                          })
                        }
                        onKeyDown={(e) => {
                          if (
                            signUpData.phoneNumber.length >= 10 &&
                            !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key) &&
                            !e.ctrlKey && !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    {error && signUpData.phoneNumber === "" && (
                      <p className="text-red-500 text-xs font-semibold mt-1">Required!</p>
                    )}
                    {error && signUpData.phoneNumber !== "" && !ValidatePhoneNumber && (
                      <p className="text-red-500 text-xs font-semibold mt-1">
                        Must consist of at least 10 digits.
                      </p>
                    )}
                  </div>
                </div>

                {/* Password */}
                <div className="space-y-1.5">
                  <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                    {t("password")}
                  </label>
                  <div className="relative group">
                    <Lock className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${iconClass}`} />
                    <input
                      type={signUpData.managePassword ? "text" : "password"}
                      placeholder={t("password")}
                      value={signUpData.password}
                      className={inputPasswordClass}
                      onChange={({ target }) =>
                        setSignUpData({ ...signUpData, password: target.value })
                      }
                    />
                    <button
                      type="button"
                      onClick={handleViewPassword}
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-500 hover:text-blue-500 transition-colors cursor-pointer"
                    >
                      {signUpData.managePassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                    </button>
                  </div>
                  {error && signUpData.password === "" && (
                    <p className="text-red-500 text-xs font-semibold mt-1">Required!</p>
                  )}
                  {error && signUpData.password !== "" && !ValidatePassword && (
                    <p className="text-red-500 text-xs font-semibold mt-1 leading-normal">
                      Must be at least 8 characters long, contain a number, an uppercase letter, and a special character.
                    </p>
                  )}
                </div>

                {/* Confirm Password */}
                <div className="space-y-1.5">
                  <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                    {t("confPassword")}
                  </label>
                  <div className="relative group">
                    <Lock className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 transition-colors ${iconClass}`} />
                    <input
                      type={signUpData.manageConfirmPassword ? "text" : "password"}
                      placeholder={t("confPassword")}
                      value={signUpData.confirmPassword}
                      className={inputPasswordClass}
                      onChange={({ target }) =>
                        setSignUpData({
                          ...signUpData,
                          confirmPassword: target.value,
                        })
                      }
                    />
                    <button
                      type="button"
                      onClick={handleConfirmViewPassword}
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-500 hover:text-blue-500 transition-colors cursor-pointer"
                    >
                      {signUpData.manageConfirmPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                    </button>
                  </div>
                  {error && signUpData.confirmPassword === "" && (
                    <p className="text-red-500 text-xs font-semibold mt-1">Required!</p>
                  )}
                  {error && signUpData.confirmPassword !== "" && (!ValidateConfirmPassword || signUpData.password !== signUpData.confirmPassword) && (
                    <p className="text-red-500 text-xs font-semibold mt-1">Passwords must match.</p>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="pt-2">
                <button
                  type="button"
                  onClick={() => next()}
                  className="w-full !py-4 bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600 hover:from-blue-500 hover:to-violet-500 text-white text-sm font-black rounded-2xl shadow-lg hover:shadow-[0_8px_25px_rgba(79,70,229,0.4)] hover:translate-y-[-2px] active:translate-y-[1px] transition-all duration-300 flex items-center justify-center min-h-[52px]"
                >
                  {t("continue")}
                </button>
              </div>

              <div className={`text-center pt-4 border-t ${borderClass}`}>
                <p className={`text-xs font-medium ${textMutedClass}`}>
                  {t("alreadyRegistered")}{" "}
                  <Link to="/login" className="text-blue-500 hover:text-blue-600 font-bold transition-all ml-1">
                    {t("Login")}
                  </Link>
                </p>
              </div>
            </div>

            {/* Step 2: Address Details */}
            <div className={current ? "space-y-6" : "hidden"}>
              <div className="space-y-2">
                <h1 className={`text-3xl font-black tracking-tight ${titleClass}`}>
                  Address Details
                </h1>
                <p className={`text-sm font-medium ${textMutedClass}`}>
                  Please provide your contact address to complete registration.
                </p>
              </div>

              <div className="space-y-4">
                {/* Street Address */}
                <div className="space-y-1.5">
                  <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                    House No, Name &amp; Address
                  </label>
                  <div className="relative group">
                    <MapPin className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none ${iconClass}`} />
                    <input
                      type="text"
                      placeholder="House No &amp; Name &amp; address"
                      value={signUpData.street}
                      className={inputClass}
                      onChange={({ target }) =>
                        setSignUpData({ ...signUpData, street: target.value })
                      }
                    />
                  </div>
                </div>

                {/* Unit / Apt */}
                <div className="space-y-1.5">
                  <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                    Address Line 2
                  </label>
                  <div className="relative group">
                    <MapPin className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none ${iconClass}`} />
                    <input
                      type="text"
                      placeholder="Apt, Suite, Unit, Building, Floor, etc."
                      value={signUpData.unit}
                      className={inputClass}
                      onChange={({ target }) =>
                        setSignUpData({ ...signUpData, unit: target.value })
                      }
                    />
                  </div>
                </div>

                {/* Country and State */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1.5">
                    <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                      Country
                    </label>
                    <div className="relative group">
                      <MapPin className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none z-10 ${iconClass}`} />
                      <select
                        value={signUpData.countryCode}
                        className={inputSelectClass}
                        onChange={({ target }) =>
                          setSignUpData({
                            ...signUpData,
                            countryCode: target.value,
                          })
                        }
                      >
                        <option value="" className={darkMode ? "bg-slate-900 text-slate-400" : "bg-white text-slate-400"}>Select Country</option>
                        {countries.map((country, index) => (
                          <option key={`${country}-${index}`} value={country} className={darkMode ? "bg-slate-900 text-white" : "bg-white text-slate-900"}>
                            {country}
                          </option>
                        ))}
                      </select>
                      <div className={`absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-sm ${dropdownArrowClass}`}>
                        ▼
                      </div>
                    </div>
                    {submitError && signUpData.countryCode !== "" && !ValidateCountryName && (
                      <p className="text-red-500 text-xs font-semibold mt-1">Country name is invalid.</p>
                    )}
                  </div>

                  <div className="space-y-1.5">
                    <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                      State / Province
                    </label>
                    <div className="relative group">
                      <MapPin className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none z-10 ${iconClass}`} />
                      <select
                        value={signUpData.province}
                        className={inputSelectClass}
                        onChange={({ target }) =>
                          setSignUpData({
                            ...signUpData,
                            province: target.value,
                          })
                        }
                      >
                        <option value="" className={darkMode ? "bg-slate-900 text-slate-400" : "bg-white text-slate-400"}>Select State</option>
                        {states.map((st, index) => (
                          <option key={`${st}-${index}`} value={st} className={darkMode ? "bg-slate-900 text-white" : "bg-white text-slate-900"}>
                            {st}
                          </option>
                        ))}
                      </select>
                      <div className={`absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-sm ${dropdownArrowClass}`}>
                        ▼
                      </div>
                    </div>
                  </div>
                </div>

                {/* City and Postal Code */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1.5">
                    <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                      City
                    </label>
                    <div className="relative group">
                      <MapPin className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none z-10 ${iconClass}`} />
                      <select
                        value={signUpData.city}
                        className={inputSelectClass}
                        onChange={({ target }) =>
                          setSignUpData({
                            ...signUpData,
                            city: target.value,
                          })
                        }
                      >
                        <option value="" className={darkMode ? "bg-slate-900 text-slate-400" : "bg-white text-slate-400"}>Select City</option>
                        {city.map((c, index) => (
                          <option key={`${c}-${index}`} value={c} className={darkMode ? "bg-slate-900 text-white" : "bg-white text-slate-900"}>
                            {c}
                          </option>
                        ))}
                      </select>
                      <div className={`absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-sm ${dropdownArrowClass}`}>
                        ▼
                      </div>
                    </div>
                  </div>

                  <div className="space-y-1.5">
                    <label className={`text-xs font-bold uppercase tracking-wider ${textMutedClass}`}>
                      Zip / Postal Code
                    </label>
                    <div className="relative group">
                      <MapPin className={`absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 pointer-events-none ${iconClass}`} />
                      <input
                        type="text"
                        placeholder="Zip / Postal Code"
                        value={signUpData.pincode}
                        className={inputClass}
                        onChange={({ target }) =>
                          setSignUpData({
                            ...signUpData,
                            pincode: target.value,
                          })
                        }
                        onKeyDown={(e) => {
                          if (
                            signUpData.pincode.length >= 6 &&
                            !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key) &&
                            !e.ctrlKey && !e.metaKey
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    {submitError && signUpData.pincode !== "" && !ValidatePinCode && (
                      <p className="text-red-500 text-xs font-semibold mt-1">Invalid Pin Code.</p>
                    )}
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 pt-2">
                <button
                  type="button"
                  onClick={() => goBack()}
                  className={`flex-1 !py-4 text-sm font-black rounded-2xl border transition-all duration-300 min-h-[52px] ${
                    darkMode
                      ? "bg-slate-800 hover:bg-slate-700 text-slate-300 hover:text-white border-slate-700"
                      : "bg-slate-100 hover:bg-slate-200 text-slate-700 hover:text-slate-900 border-slate-200"
                  }`}
                >
                  {t("Back")}
                </button>

                <button
                  type="button"
                  disabled={loading}
                  onClick={() => handleComplete()}
                  className="flex-1 !py-4 bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600 hover:from-blue-500 hover:to-violet-500 text-white text-sm font-black rounded-2xl shadow-lg hover:shadow-[0_8px_25px_rgba(79,70,229,0.4)] hover:translate-y-[-2px] active:translate-y-[1px] transition-all duration-300 flex items-center justify-center min-h-[52px]"
                >
                  {loading ? <Loading /> : "Complete Registration"}
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}

export default SignupPage;
